import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/auth";
import utilSlices from "./slices/util";
import customerSlice from "./slices/customer";
import userSlice from "./slices/users";
import { useDispatch, useSelector } from "react-redux";
import { TypedUseSelectorHook } from "react-redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import organisationSlice from "./slices/organisation";
import orderSlice from "./slices/order";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: [
    "authReducer",
    "organisationReducer",
    "customerReducer",
    "userReducer",
  ],
};

const rootReducer = combineReducers({
  authReducer: authSlice,
  utilReducer: utilSlices,
  organisationReducer: organisationSlice,
  userReducer: userSlice,
  customerReducer: customerSlice,
  orderReducer: orderSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
